import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';

import {useNavigate} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

import {deleteErrorMessage} from '../reducers/recordsSlice';

import {ModalInfo} from 'pac-ux-components';

import {useErrorMessage} from 'hooks/useErrorMessage';

export const ErrorMessageComponent = ({ redirectTo }) => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const errorMessage = useErrorMessage();

    const handleModalInfoClose = () => {
        dispatch(deleteErrorMessage(errorMessage.id));
        navigate(redirectTo);
        return false;
    };

    if (typeof errorMessages === 'undefined') {
        return null;
    }

    if (errorMessage) {
        return (
            <ModalInfo
                label=""
                onClose={handleModalInfoClose}
                text={errorMessage.message}
                title={I18n.get('Error')}
            />
        );
    }

    return null;
};

ErrorMessageComponent.propTypes = {
    redirectTo: PropTypes.string,
};

ErrorMessageComponent.defaultProps = {
    redirectTo: '/',
};
